export enum RoleDTO {
  SYSTEM_ADMIN = "SYSTEM_ADMIN",
  ACCOUNT_ADMIN = "ACCOUNT_ADMIN",
  USER = "USER",
  SUPPORT = "SUPPORT",
}

export const isSupportUser = (roles: RoleDTO[]): boolean =>
  roles.includes(RoleDTO.SUPPORT);

// Dexibit staff rather than members of the account. Kept separate from
// isSupportUser, which the automation view/manage rules and the BFF's
// isSupportCreated derivation both depend on.
export const isInternalUser = (roles: RoleDTO[]): boolean =>
  roles.includes(RoleDTO.SUPPORT) || roles.includes(RoleDTO.SYSTEM_ADMIN);

export const isUserAdmin = (roles: RoleDTO[]): boolean => {
  return (
    roles.includes(RoleDTO.ACCOUNT_ADMIN) ||
    roles.includes(RoleDTO.SYSTEM_ADMIN) ||
    roles.includes(RoleDTO.SUPPORT)
  );
};
